import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { FormValidation, SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import Swal from 'sweetalert2';
import { AppSettings } from 'src/app/services/AppSettings';
import { BENEFITS_KEY, PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { ManageTemplateComponent } from '../manage-template/manage-template.component';
import { PlanCardComponent } from '../plan-card/plan-card.component';

@Component({
  selector: 'app-manage-workspace',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent, PlanCardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './manage-workspace.component.html',
  styleUrls: ['./manage-workspace.component.scss' ,  '../../../../../styles/admin/style.scss',
    "../../../../../styles/admin/app.scss"]
})
export class ManageWorkspaceComponent extends FormValidation {
  PLANMAX : number = 0;
  AVAILABLE : number = 0;
  ALLOCATED : number = 0;
  fields: Array<Partial<TEXT_FIELDS>>;
  columns: Array<Partial<TEXT_FIELDS>>;
  teamDetails !: any;
  teams = new BehaviorSubject([]);
  teamId: any;
  focused : boolean = true;
  payload = {
    limit: 10,
    searchContent : null,
    status : null,
    searchAfterKey : null
  };
  filterData = [
    {
      label: 'Status',
      payload: 'status',
      options: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
        { value: 'DEACTIVATED', label: 'Deactivated' },
      ],
    }
  ]
  prevSearchAfterKey : any;
  employeePrevSearchAfterKey : any;
  stopScroll : boolean = false;
  businessId: any;
  businessEmail: any;
  allocationCards = [
    {
      name : "Plan Max",
      value : null
    },
    {
      name : "Allocated",
      value : null
    },
    {
      name : "Active",
      value : null
    },
  ];

  constructor(private API: ApiService, private aRoute: ActivatedRoute,
    private pricePlanService : PricePlanService ,
    private customerService :  CustomerService , private util : UtilService
  ) {
    super();
    this.aRoute.queryParams.subscribe(res => {
      this.teamId = res.teamId;
      this.businessId = res.id;
      this.businessEmail = res.businessEmail;
    });

    this.fields = [
      { label: "Workspace Name", key: 'teamName' },
      { label: "Owner", key: 'owner' },
      { label: "Members", key: 'members' },
    ];

    this.columns = [
      { label: 'Workspace Name', key: 'teamName' },
      { label: 'User', key: 'userName' },
      { label: 'Email', key: 'email' },
      { label: 'Members', key: 'memberCnt' },
    ];

  }

  ngOnDestroy(): void {
    this.teams.unsubscribe();
  }


  ngOnInit(): void {
      this.getTeam();
  }

  updateTeam(event) {
    let arr: any[] = [];
    arr.push(event);
    const updatedArray = arr.map(obj=>{
      const {members, ...rest} = obj;
      return rest;
    });
    this.API.create('business/manageTeams', updatedArray).subscribe(res => {
      if (res && res.code === '00000') {
        this.teamDetails = event;
        Swal.fire({
          icon : "success",
          title : "Workspace Updated",
          text : "Updated Workspace Sucessfully!",
          showConfirmButton: false,
          allowOutsideClick : false,
          timer: 1000,
        })
      }
      this.util.stopLoader();
    });
  }

  async updateTeamMembers(members: any) {

    const userData = members.value;
    const updatedData =  JSON.parse(JSON.stringify(this.teams.getValue()));

    if(members.checked){
      this.util.startLoader();

      const plan = await this.customerService.getUserPLanBenefits(userData.teamsOwnerId , 'TEAM_WORKSPACES');

      if(plan.available > 0){
           this.updateMembersBulk(userData);
      }
      else{

          updatedData.forEach(res=>{
            if(res.teamId === userData.teamId){
              res.status = "INACTIVE";
            }
          });
          this.teams.next(updatedData);
          this.pricePlanService.expiredPopup(
            "TEAM_WORKSPACES",
            "PAY",
            null,
            null,
            null,
            null,
            plan.available,
            plan.actual,
            plan.utilized,
            plan.promotional
          );
          this.util.stopLoader();
      }

    }
    else{
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick : false,
        title : "Inactive Workspace",
        text : `Are you sure you want to inactive ${userData.teamName}?`
      }).then(res=>{


        if(res.isConfirmed){
          this.updateMembersBulk(userData);
        }
        else{
          updatedData.forEach(res=>{
            if(res.teamId === userData.teamId){
              res.status = "ACTIVE";
            }
          });
          this.teams.next(updatedData);
        }

      });
      this.util.stopLoader();
    }





  }
  updateMembersBulk(data){
     this.API.create('business/manageTeams', [data]).subscribe(res => {
      if (res && res.code === '00000') {
        Swal.fire({
          icon : "success",
          title : 'Workspace Updated!',
          text : "Workspace updated successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.teams.next([]);
          this.getTeam();
      }, 1000);
      this.util.stopLoader();

      }
    });
  }

  getTeamList(payload: Object): Observable<any> {
    return this.API.create('teams/findTeamsOfBusiness', payload);
  }
  activecount:number=0;
  getTeam() {
    this.util.startLoader();
       this.getTeamList({ businessId: this.businessId, ...this.payload }).subscribe(response => {
      this.util.stopLoader();
      if (response.code === AppSettings.SUCESS_CODE) {
        const teams = response.data.teams;
        const searchKey = response.data.searchAfterKey;

         if(response?.data?.teamsActiveCount && this.payload.searchAfterKey==null || response?.data?.teamsActiveCount==0 && this.payload.searchAfterKey==null){
           this.activecount= response?.data?.teamsActiveCount;
         }

        if (teams) {
          const current = teams;
          const exist = this.teams.getValue();
          const mappedData = [...exist, ...current];
          mappedData.forEach(ele => {
            const userData = ele.userDetail;
            ele.userName = userData.firstName + " " + userData.lastName;
            ele.email = userData.email;
          });
          this.teams.next(mappedData);
        }

        if (teams != null && (teams.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))) {
          this.stopScroll = true;
        }
        this.prevSearchAfterKey = searchKey;


        let plan = response.data.customerPlanUsage;
        let found = (plan.benefitsUsages && plan.benefitsUsages.
          find(x => (x.benefitKey as BENEFITS_KEY) === 'TEAM_WORKSPACES'));
        if (found) {
          this.PLANMAX = found.actual;
          this.AVAILABLE = found.available;
          this.ALLOCATED = found.utilized;
          this.allocationCards[0].value = this.PLANMAX;
          this.allocationCards[1].value = this.ALLOCATED;
          this.allocationCards[2].value = this.activecount;
        }

        // const { adminUserData, ...rest } = response.data.teams;
        // let data = {
        //   ...rest,
        //   owner: adminUserData.firstName + " " + adminUserData.lastName,
        //   members: rest.memberCnt,
        //   userId : adminUserData.userId,
        //   adminUserData : adminUserData
        // }
        this.teamDetails = {};

      }

    });

  }


  onSearch(value , obj : ManageWorkspaceComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.teams.next([]);
    obj.getTeam();
  }

  onFilter(data , obj : ManageWorkspaceComponent){
    console.log("FILTERED DATA" , data);
    obj.payload = {
      ...obj.payload,
      status : data.status,
      searchAfterKey : null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.teams.next([]);
    obj.getTeam();
  }

  onScroll(obj : ManageWorkspaceComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getTeam();
    }
  }

}
